<template>
  <div class="logo" @click="$router.push('/')">
    <img src="../assets/image/all/logo.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
img {
  height: 45px;
  width: 155px;
}
</style>